export default "__VITE_ASSET__CYiGbo$j__"